import {AfterViewInit, Component, HostBinding, Input, OnInit} from '@angular/core';
import {FilterOutputModel, GeneralService, SnackbarService} from 'app/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableComponent} from 'app/components/new-table/table/table.component';
import {TableColumnDef} from 'app/shared/tables/table-column-def';
import {StoresDataService} from 'app/domain/shops-wrapper/shops/services/stores.data.service';
import {CategoryShelfModel, ClusterShelfModel, ShelfModel} from 'app/domain/shops-wrapper/shops/model/models';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'pr-floorplan-shelves',
  templateUrl: './floorplan-shelves.component.html',
    styleUrls: ['./floorplan-shelves.component.scss', '../../../../../components/new-table/base-table.scss']
})
export class FloorplanShelvesComponent extends TableComponent implements OnInit, AfterViewInit  {
    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    shelves: Array<ShelfModel>;
    features: any;
    @Input()
    storeId: number;
    originalData;

    constructor(
        snackBar: SnackbarService,
        generalService: GeneralService,
        router: Router,
        activatedRoute: ActivatedRoute,
        private storesDataService: StoresDataService
    ) {
        super(snackBar, generalService, router, activatedRoute);
    }

    ngOnInit(): void {
        this.setTableColumns();
    }

    ngAfterViewInit(): void {
        this.saveTableState();
    }

    loadData(event: any) {
        this.isLoading = true;

        let sort = this.sortBy;
        if (event.sortField !== undefined && event.sortField !== null) {
            const columnDef = this.columnsData.find(
                (c: TableColumnDef) => c.columnDef === event.sortField
            );

            if (columnDef?.showSort !== false)
                sort = ((columnDef?.sortColumnDef) ? columnDef.sortColumnDef : event.sortField) + (event.sortOrder === 1 ? ' asc' : ' desc');
        }

        let filters: FilterOutputModel[] = [];
        if (event.filters !== undefined && event.filters !== null) {
            filters = Object.keys(event.filters)
                .filter(e => e !== 'global')
                .map((e) =>
                    <FilterOutputModel>{
                        filterValues: [event.filters[e].value],
                        columnDef: this.columnsData.find(
                            (c: TableColumnDef) => c.columnDef === e
                        ),
                    }
                );
        }

        forkJoin(
            {shelves: this.storesDataService.fetchShelves(), d: this.storesDataService.fetchCategoryShelves(
            event.rows,
            event.first,
            sort,
            event.globalFilter,
            filters,
            this.storeId
        )})
                .subscribe(({shelves, d}) => {
                        this.shelves = shelves;
                        this.tableData = d.items;
                        this.tableData.forEach(z => {
                            z.FirstShelf = z.FirstShelf ? z.FirstShelf : new ClusterShelfModel(0, 0, null);
                            z.SecondShelf = z.SecondShelf ? z.SecondShelf : new ClusterShelfModel(0, 0, null);
                            z.ThirdShelf = z.ThirdShelf ? z.ThirdShelf : new ClusterShelfModel(0, 0, null);
                        });

                        this.originalData = JSON.parse(JSON.stringify(this.tableData));
                        this.totalRecords = d.total_count;
                        this.tableCountLoaded.emit(this.totalRecords);
                        this.tableDataLoaded.emit(this.tableData);
                        this.setTableColumns();
                        this.isLoading = false;
                    },
                    (error: any) => {
                        this.isLoading = false;
                        this.messageOnFetchData(error);
                    },
                    () => {
                        this.isLoading = false;
                    }
                );

            this.clearStateFromFilters();
    }

    protected setTableColumns() {
            const tableInfo = CategoryShelfModel.tableInfo();
            this.tableId = tableInfo.tableId;
            this.columnsData = tableInfo.columns;

            this.setAllParameters();
    }

    public getMetersSum(row): number {
        let sum = 0;

        sum += row.FirstShelf.Shelf?.Id ? row.FirstShelf.Shelf.Meters * row.FirstShelf.Count : 0;
        sum += row.SecondShelf.Shelf?.Id ? row.SecondShelf.Shelf.Meters * row.SecondShelf.Count  : 0;
        sum += row.ThirdShelf.Shelf?.Id ? row.ThirdShelf.Shelf.Meters * row.ThirdShelf.Count  : 0;

        return sum;
    }

    public save() {
        this.storesDataService.updateCategoryShelves(this.storeId, this.tableData).subscribe(x => {
            this.snackBar.info('Regały zostały zapisane.');
        });
    }

    public compareShelves(x, y) {
        return x.Id === y.Id;
    }

    public reset() {
        this.tableData = JSON.parse(JSON.stringify(this.originalData));
    }
}
